// src/AddCampaign.tsx
import React from 'react';
import AddCampaignContent from './AddCampaignContent';

const AddCampaign: React.FC = () => (
    <AddCampaignContent />
);

export default AddCampaign;
